import React from 'react';
import { createRoot } from 'react-dom/client';
import PageTemplateModal from 'components/page_templates/PageTemplateModal';
import { TemplateTypes } from 'components/page_templates/TemplateController';
import type { NoteTemplate } from 'components/framework/models';
import type { GlobalNoteTemplate } from 'components/page_templates/types';

interface TemplatePayload {
  template: NoteTemplate | GlobalNoteTemplate;
  isGlobal: boolean;
}

export async function chooseTemplate({
  showWhiteboardTemplates,
  projectId,
}): Promise<TemplatePayload | null> {
  const modalWindowEl = document.createElement('div');
  document.body.appendChild(modalWindowEl);

  const root = createRoot(modalWindowEl);

  return new Promise<TemplatePayload | null>((resolve, reject) => {
    root.render(
      <PageTemplateModal
        projectId={projectId}
        templateType={
          showWhiteboardTemplates ? TemplateTypes.all : TemplateTypes.note
        }
        placeTemplate={(template, isGlobal) => {
          root.unmount();
          resolve({ template, isGlobal });
        }}
        closeTemplateModal={() => {
          root.unmount();
          resolve(null);
        }}
      />
    );
  });
}
